import { create } from "zustand";
import { persist } from "zustand/middleware";

const useStore = create(
  persist((set, get) => ({
    redirectUri: null,
    user: {},
    lng: "nl",
    languageSaved: false,
    checkCount: 0,

    setRedirectUri: (redirectUri) => set(() => ({ redirectUri: redirectUri })),
    setUser: (user) => set(() => ({ user: user })),
    setCheckCount: (checkCount) => set(() => ({ checkCount: checkCount })),
    setLng: (lng) => set(() => ({ lng: lng })),
    setLanguageSaved: (languageSaved) =>
      set(() => ({ languageSaved: languageSaved })),

    resetRedirectUri: () => set(() => ({ redirectUri: null })),
    resetUser: () => set(() => ({ user: {} })),
    resetCheckCount: () => set(() => ({ checkCount: 0 })),
    resetLng: () => set(() => ({ lng: "nl" })),
    resetLanguageSaved: () => set(() => ({ languageSaved: false })),
  }))
);

export default useStore;
